// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"d7a60919a854e6f3","4635":"87a8bdc06f131293"}[chunkId] + ".css";
};